import React, { useCallback, useEffect, useState } from "react";
import { PartnerOfferingLocation } from "../../data/partner_offering";
import { LocationPicker } from "./space_picker";
import { useAnalytics } from "../../lib/analytics/analytics";

export interface PartnerLocationPickerProps {
  locations: PartnerOfferingLocation[];
  value?: string;
  onChange: (ID: string) => void;
  disabled: boolean;
}

export function PartnerLocationPicker(props: PartnerLocationPickerProps) {
  const { value, locations, onChange, disabled = false } = props;
  const options = locations.map((l) => ({
    label: l.locationDisplay
      ? l.locationDisplay
      : `${l.location.city} - ${l.location.streetAddress}`,
    value: l.id,
  }));
  const analytics = useAnalytics();
  const [selectedLocation, setSelectedLocation] = useState<string>();
  const onSelectLocation = useCallback(
    (value: any) => {
      const location = options.find((l) => l.value === value);
      setSelectedLocation(location?.label);
      onChange(value);

      const pl = locations.find((l) => l.id === value);

      if (!pl) {
        return;
      }

      analytics.event(
        "Location Select Click",
        {
          "Location Name": pl.location.name,
          "Location UUID": pl.location.id,
          Source: "WL",
        },
        { onlyProviders: ["mixpanel", "customerio"] }
      );
    },
    [analytics, onChange, options, locations]
  );

  useEffect(() => {
    if (value) {
      const location = options.find((l) => l.value === value);
      setSelectedLocation(location?.label);
    } else {
      setSelectedLocation("");
    }
  }, [value, setSelectedLocation, options]);

  return (
    <LocationPicker
      onChange={onSelectLocation}
      value={selectedLocation}
      options={options}
      disabled={disabled}
    />
  );
}
